<template>
  <div class="deputies">
    <div class="deputies-title">
      <div class="title-medium-regular">{{ title }} :</div>
      <ListGridRadioButtons
        :is-list-active="!isDisplayBadges"
        @toggle-display="isDisplayBadges = !isDisplayBadges"
      />
      <button
        v-if="deputiesList.length > LIST_LIMIT"
        v-focus
        class="btn-secondary"
        @click="() => (isFullList = !isFullList)"
      >
        Voir {{ isFullList ? "moins" : "plus" }}
      </button>
    </div>
    <div v-if="isDisplayBadges" class="deputies-picture-grid">
      <PersonBadge
        v-for="deputy in showDeputiesList"
        :key="deputy._id"
        :person="{ ...deputy, is_prm: true }"
      />
      <div v-if="deputiesList.length > LIST_LIMIT && !isFullList">
        + {{ deputiesList.length - LIST_LIMIT }}
      </div>
    </div>
    <div v-else class="deputies-list">
      <div
        v-for="(deputy, idx) in showDeputiesList"
        :key="deputy._id"
        class="deputy-name"
      >
        <component
          :is="
            deputy.prm_status || deputy.has_social_media
              ? AuthorPrmTooltip
              : 'span'
          "
          :author-id="deputy._id"
          :prm-level="deputy.prm_status"
          :is-stakeholder="deputy.has_social_media"
          is-top
          :class="{ 'has-link': deputy.prm_status || deputy.has_social_media }"
        >
          {{ deputy.name }} </component
        ><template v-if="idx < showDeputiesList.length - 1">, </template>
      </div>
      <span v-if="deputiesList.length > LIST_LIMIT && !isFullList">, ...</span>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import ListGridRadioButtons from "@follaw-fr/components/reusable/atoms/ListGridRadioButtons.vue";
import PersonBadge from "@follaw-fr/components/reusable/molecules/PersonBadge.vue";
import AuthorPrmTooltip from "@follaw-fr/components/reusable/atoms/AuthorPrmTooltip.vue";

const props = defineProps({
  deputiesList: { type: Array, required: true },
  title: { type: String, default: "Député(e)s" },
});

const LIST_LIMIT = 25;

const isFullList = ref(false);

const isDisplayBadges = ref(true);

const showDeputiesList = computed(() => {
  return isFullList.value
    ? props.deputiesList
    : props.deputiesList.slice(0, LIST_LIMIT);
});
</script>

<style scoped lang="scss">
.deputies-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--clr-s8);
}

.deputies {
  display: flex;
  flex-direction: column;
  gap: 8px;
  .deputies-list {
    display: flex;
    flex-wrap: wrap;
    text-transform: capitalize;
    .deputy-name {
      display: flex;
      white-space: nowrap;
      &:not(:last-child) {
        margin-right: 4px;
      }

      .has-link {
        cursor: pointer;
        color: var(--clr-link-default);
      }
    }
  }

  .deputies-picture-grid {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }
}
</style>
